module.exports = __webpack_public_path__ + "static/media/brand_2.png";